import { useEffect, useState } from "react";
import confetti from "canvas-confetti";

export default function DefaultProgressBar({
  currValue = 0,
  targetValue = 0,
  label = "",
  successColor = "",
  progressColor = "",
}) {
  const [percentage, setPercentage] = useState(0);
  const [hasCelebrated, setHasCelebrated] = useState(false);

  useEffect(() => {
    const pct = Math.min((currValue / targetValue) * 100, 100);
    setPercentage(pct);

    if (pct === 100 && !hasCelebrated) {
      confetti({
        particleCount: 75,
        spread: 70,
        origin: { y: 0.6 },
      });
      setHasCelebrated(true);
    } else if (pct < 100 && hasCelebrated) {
      setHasCelebrated(false);
    }
  }, [currValue, targetValue, hasCelebrated]);

  return (
    <div className="w-full">
      {label && (
        <div className="mb-1 text-sm font-medium text-gray-700">{label}</div>
      )}
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div
          className={
            "h-full text-center text-xs font-medium text-white transition-all duration-300 ease-in-out " +
            (percentage === 100 ? successColor : progressColor)
          }
          style={{ width: `${percentage}%` }}
        >
          {Math.floor(percentage)}%
        </div>
      </div>
    </div>
  );
}
